module.exports = __webpack_public_path__ + "358ceefbb1cb8f5ebc114d264f27635a.png";